module.exports = require('./lib/utils')(require('ramda'));
